import React, {Component, Fragment} from 'react';
import { adminloadTP, AuthenticatedUser, stopTimer, sendTournamentMailByContent } from "../../../api";
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'
import { AvField, AvForm } from 'availity-reactstrap-validation';
import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';
import Editor from "../../../common/quillEditor";
import { FlowDataEntry } from '../../../common/flowDataEntry'

const defaultTemplate = [{
    from: 'notifications@mg.lastingimpact.info',
    to: '',
    subject: 'Welcome to the Lasting Impact Tournament!',
    title: 'Lasting Impact | Tournament Notification',
    blocks: [
      {
        blockId: 'imageFull',
        link: 'http://www.impacttournaments.com',
        src: 'http://www.impacttournaments.com/small-bubble-logo.png'
      },
      {
        blockId: 'internal',
        fields: [
          'FIRSTNAME',
          'TOURNAMENT-TITLE'
        ],
        keys: [
          'user.firstname',
          'tournament.title'
        ]
      },
      {
        blockId: 'divider'
      },
      {
        blockId: 'socialFooter'
      }
    ]
  } ]


class TournamentAdminMessenger extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;

        this.state = {
            loading: true,
            open: false,
            user: user,
            pid: params.pid,
            templateJson: JSON.stringify(defaultTemplate),
            recipJson: JSON.stringify([]),
            data: {}
        }
    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('none', 'e', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({tData: d2.tournamentPage, tUsers: d2.tUsers, loading: false});                    

                }
            });
        } else this.setState({ loading: false});
    };

    onValidSubmit = (event, values) => {
        const template = JSON.parse(this.state.templateJson);
        const recipJ = JSON.parse(this.state.recipJson);

        const recip = values.recipients;
        const eRecip = values.eventRecipients;
        template.subject = values.title;
        sendTournamentMailByContent(this.state.tData._id, this.state.templateJson, values.title, this.state.data.content, {
            sendToMe: recip === 'me',
            sendToJudges: ['ju', 'jc', 'jg', 'al'].includes(recip),
            sendToCommunityJudges: ['j1'].includes(recip),
            sendToAlumniJudges: ['j2'].includes(recip),
            sendToParentJudges: ['j3'].includes(recip),
            sendToCompetitors: ['co', 'cg', 'jc', 'al'].includes(recip),
            sendToGuests: ['gu', 'cg', 'jg', 'al'].includes(recip),
            sendToRecips: ['re'].includes(recip)
        }, eRecip, {tournament: this.state.tData._id}, recipJ)
    };
    
    onInvalidSubmit = (event, errors, values) => {
        this.setState({errors, values});
    };

    onRecipJsonChanged = (event) => {
        this.setState({recipJson: event.json});
    }

    ontemplateJsonChanged = (event) => {
        this.setState({templateJson: event.json});
    }

    handleContentChange = (value) => {
        this.setState({
            data: { ...this.state.data, content: value }
        });
    }

    componentDidMount() {
        this.loadTournamentPage();        
    }

    render() {
        const defaultValues = this.state.data;
        const { tData, user} = this.state;

        if (this.state.loading) { return null; }
        stopTimer();     
        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Send Message - ${user.displayname}`} title3=""
            bcTitle="Send Message" bcParents={[
                {name: tData.title, url: `/pages/tournament/${tData._id}`},
                {name: "Administration", url: `/tournament/admin/${tData._id}`}
            ]}
        >            
            <Fragment>
                <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={defaultValues}>
                    <FlowDataEntry saveTitle="Send">
                        <Fragment>
                            <AvField label="Recipients" grid={{xs: 10}} name="recipients" id="recipients" type="select">                                 
                                <option disabled value="">Select Group</option>                                 
                                <option value="me" key="me" >Me Only - Test Message</option>                                                        
                                <option value="al" key="al">All</option>                                 
                                <option value="ju" key="ju">All Judges</option>                                                             
                                <option value="j1" key="ju">Community Judges</option>                                                             
                                <option value="j2" key="ju">Alumni Judges</option>                                                             
                                <option value="j3" key="ju">Parent Judges</option>                                                             
                                <option value="co" key="co" >Competitors</option>                                 
                                <option value="gu" key="gu" >Guests</option>                                                        
                                <option value="jc" key="jc" >Judges and Competitors</option>                                                        
                                <option value="jg" key="jg" >Judges and Guests</option>                                                        
                                <option value="cg" key="cg" >Competitors and Guests</option>                                                        
                                <option value="re" key="re" >Listed Recipients</option>                                                        
                            </AvField>
                            <AvField label="EventRecipients" grid={{xs: 10}} name="eventRecipients" id="eventRecipients" type="select">                                 
                                <option disabled value="">Select Event</option>                                 
                                <option value="al" key="al">All</option>
                                {
                                    tData.events.map(x=> {
                                        return (<option value={x._id} key={x._id}>{x.abbr}</option>)
                                    })
                                }

                            </AvField>
                            <AvField label="Subject" grid={{xs: 10}} name="title" id="title" type="text" />
                        </Fragment>

                        <Editor 
                            content={defaultValues.content}
                            onContentChange={this.handleContentChange}
                        />

                        <Fragment>                    
                            <div className="row">
                                <div className="col-sm-2"> Recipients
                                </div>
                                <div className="col-sm-10">  
                                    <JSONInput
                                    id          = 'a_unique_id'
                                    locale      = { locale }
                                    height      = '550px'
                                    width       = '100%'
                                    placeholder = { this.state.recipJson ? JSON.parse(this.state.recipJson) : {} }
                                    onChange = {this.onRecipJsonChanged}
                                    />
                                </div>
                            </div>
                        </Fragment> 

                        <Fragment>                    
                            <div className="row">
                                <div className="col-sm-2"> JSON
                                </div>
                                <div className="col-sm-10">  
                                    <JSONInput
                                    id          = 'a_unique_id'
                                    locale      = { locale }
                                    height      = '550px'
                                    width       = '100%'
                                    placeholder = { this.state.templateJson ? JSON.parse(this.state.templateJson) : {} }
                                    onChange = {this.ontemplateJsonChanged}
                                    />
                                </div>
                            </div>
                        </Fragment>                                                                                                                                

                    </FlowDataEntry>  
                </AvForm>  
            </Fragment>
            </TournamentPageTemplate>

        )
    }
}

export default TournamentAdminMessenger;